import { useState, type FormEvent } from 'react'
import { ApkDownloadLink } from '../install/ApkDownloadLink'
import { AUTH_STRATEGY, BUILD_TARGET } from '../../shared/config'
import { useAuth } from './useAuth'

/** Login stub: no real IdP yet, but the token model of §8 is real. */
export function LoginScreen() {
  const { login } = useAuth()
  const [name, setName] = useState('Student')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(event: FormEvent): Promise<void> {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await login(name.trim() || 'Student')
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : String(cause))
    } finally {
      setBusy(false)
    }
  }

  return (
    <main className="centered">
      <form className="card" onSubmit={(e) => void submit(e)}>
        <h1>Sciolingo</h1>
        <p className="muted">
          Přihlášení je zatím pouze zástupné. Ověřuje model tokenů podle sekce 8 specifikace, nikoli
          skutečnou identitu.
        </p>

        <label className="field">
          <span>Jméno</span>
          <input value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" />
        </label>

        <button className="button button--primary" type="submit" disabled={busy}>
          {busy ? 'Přihlašuji…' : 'Pokračovat'}
        </button>

        {error ? <p className="error">{error}</p> : null}

        <p className="muted small">
          build <code>{BUILD_TARGET}</code> · auth <code>{AUTH_STRATEGY}</code>
        </p>

        <p>
          <ApkDownloadLink />
        </p>
      </form>
    </main>
  )
}
